export default angular
  .module("ScriptCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ScriptController", [
    "$anchorScroll",
    "$scope",
    "$timeout",
    "$location",
    "$state",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "Message",
    "System",
    "ScriptLoading",
    "Permissions",
    function (
      $anchorScroll,
      $scope,
      $timeout,
      $location,
      $state,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      Message,
      System,
      ScriptLoading,
      Permissions,
    ) {
      $scope.userRoles = Permissions.getUserPermissions($rootScope.loggedUser);
      // Page name to rootscope. Has impact on left menu.
      $rootScope.page = "scripts";

      // fetching language from rootscope.
      $scope.language = $rootScope.loggedUser.language;

      // If field is changed in script details. Trigger this. This has impact
      // what will be saved when user clicks save.
      // This will also trigger searching data in certain cases like cochrane
      // or journal articles.
      $rootScope.changedFields = new Map();
      $scope.changedField = function (entity) {
        $rootScope.changedFields.set(entity, true);
      };

      // list of scripts messages/tasks
      const loadMessages = scriptId => Message
        .loadMessagesLinkedToScript(scriptId, (data, status) => {
          $scope.messagesofscript = data;
          if ($scope.messagesofscript) {
            $scope.messagesofscript.forEach((item) => {
              item.TITLE = (item.TITLE || "").replace(/<\/?[^>]+>/gi, "");
            });
          }
          if (status === 200) {
            ScriptLoading
              .markCommentsMessagesTasksResourceLoaded("messagesLinked");
          }
        });

      $scope.$on("loadScriptMessage", (e, params) => {
        loadMessages(params);
      });

      $scope.openAlias = function (aliasId) {
        $location.path(`/alias/${aliasId}`);
      };

      // Open single script from list view. Load all script data.
      let selectedScript = "";
      $scope.openScript = function (scriptID) {
        $rootScope.changedFields = new Map();
        $rootScope.page = "scriptdetails";
        $rootScope.pageID = scriptID;
        selectedScript = scriptID;
        Scripts.loadScriptMetaByID(scriptID, (data, status) => {
          $scope.scriptmeta = data;

          // handling of keywords for ngtags.
          $scope.scriptmeta.KEYWORDS_SPLITTED = ($scope.scriptmeta.KEYWORDS || "")
            .split(";")
            .filter(t => t !== "" && t !== "0");

          // handling of evidence base for ngtags.
          $scope.scriptmeta.EVIDENCE_TEAMS_SPLITTED = ($scope.scriptmeta.EVIDENCE_TEAMS || "")
            .split(",")
            .filter(t => t !== "" && t !== "0");

          // handling of checkboxes
          $scope.PHYSICIAN_CHECKED = false;
          $scope.NURSE_CHECKED = false;
          $scope.CITIZEN_CHECKED = false;
          if ($scope.scriptmeta.PHYSICIAN) {
            if ($scope.scriptmeta.PHYSICIAN == "T") {
              $scope.PHYSICIAN_CHECKED = true;
            }
          }
          if ($scope.scriptmeta.NURSE) {
            if ($scope.scriptmeta.NURSE == "T") {
              $scope.NURSE_CHECKED = true;
            }
          }
          if ($scope.scriptmeta.CITIZEN) {
            if ($scope.scriptmeta.CITIZEN == "T") {
              $scope.CITIZEN_CHECKED = true;
            }
          }

          $scope.scriptPermissions = Permissions.rightsForScript(
            $rootScope.loggedUser,
            $scope.scriptmeta,
          );

          if (status === 200) {
            ScriptLoading.markMetadataResourceLoaded("metadata");
          }
          Scripts.loadScriptSummaryByID(scriptID, "en", (summary) => {
            $scope.scriptsummary = summary;
            $scope.scriptsummary.SCRIPT_ID = $scope.scriptmeta.ID;
            if (status === 200) {
              ScriptLoading.markSummaryRisksResourceLoaded("summaryEN");
            }
          });
          $("#script-list").collapse("hide");
        });
        Scripts.loadScriptSummaryByID(
          scriptID,
          $rootScope.loggedUser.language,
          (data, status) => {
            $scope.scriptsummarylang = data;
            if (status === 200) {
              ScriptLoading.markSummaryRisksResourceLoaded("summaryUserLang");
            }
          },
        );
        $scope.scriptrisk = [];
        $scope.riskExist = false;
        Scripts.loadScriptRiskByID(scriptID, (data, status) => {
          $scope.scriptrisk = data;
          if ($scope.scriptrisk) {
            $scope.riskExist = true;
          }
          if (status === 200) {
            ScriptLoading.markSummaryRisksResourceLoaded("risk");
          }
        });
        Scripts.loadScriptEvindenceByID(scriptID, (data, status) => {
          $scope.scriptevidence = data;
          if (status === 200) {
            ScriptLoading.markEvidenceResourceLoaded("evidence");
          }
        });
        Scripts.loadScriptCochraneByID(scriptID, (data, status) => {
          $scope.scriptcochrane = data;
          if (status === 200) {
            ScriptLoading.markEvidenceResourceLoaded("cochrane");
          }
        });
        Scripts.loadScriptEBMGuidelinesByID(scriptID, (data, status) => {
          $scope.scriptebm = data;
          if (status === 200) {
            ScriptLoading.markEvidenceResourceLoaded("EBMGuidelines");
          }
        });
        Scripts.loadScriptJournalArticlesByID(scriptID, (data, status) => {
          $scope.scriptjournal = data;
          if (status === 200) {
            ScriptLoading.markEvidenceResourceLoaded("journal");
          }
        });
        Scripts.loadScriptWWWlinksByID(scriptID, (data, status) => {
          $scope.scriptwwwlink = data;
          if (status === 200) {
            ScriptLoading.markEvidenceResourceLoaded("WWWLinks");
          }
        });
        Scripts.loadScriptOtherEvidenceByID(scriptID, (data, status) => {
          $scope.scriptotherevidence = data;
          if (status === 200) {
            ScriptLoading.markEvidenceResourceLoaded("otherEvidence");
          }
        });
        // Return messages loaded in script content controller
        Scripts.loadScriptCodeAliasesByID(scriptID, (data) => {
          $scope.scriptcodealias = data;
          for (let i = 0; $scope.scriptcodealias.length > i; i++) {
            (function (cntr) {
              $scope.scriptcodealias[cntr].ORIGINAL_NAME = $scope.scriptcodealias[cntr].NAME;
              System.loadAliasTestingNames(
                $scope.scriptcodealias[cntr].SYS_ID,
                $rootScope.loggedUser.language,
                (names) => {
                  $scope.scriptcodealias[cntr].testingnames = names;
                },
              );
            }(i));
          }
        });
        Scripts.loadScriptPhraseAliasesByID(
          scriptID,
          $rootScope.loggedUser.language,
          (data, status) => {
            $scope.scriptphrasealias = data;
            if (status === 200) {
              ScriptLoading.markContentLogicResourceLoaded("phraseAliases");
            }
          },
        );
        Scripts.loadScriptFlowByID(
          scriptID,
          (data, status) => {
            $scope.scriptflows = data;
            if (status === 200) {
              ScriptLoading.markContentLogicResourceLoaded("scriptFlow");
            }
          },
        );
        System.loadFlowOperator((data, status) => {
          $scope.flowoperators = data;
          if (status === 200) {
            ScriptLoading.markContentLogicResourceLoaded("flowOperators");
          }
        });
        System.loadFlowAlias(scriptID, (
          data,
          status,
        ) => {
          $scope.flowAliases = data;

          if (status === 200) {
            ScriptLoading.markContentLogicResourceLoaded("flowAliases");
          }
          System.loadFlowGroup((data2) => {
            if (status === 200) {
              ScriptLoading.markContentLogicResourceLoaded("flowAliasGroups");
            }

            System.loadFlowProperty((datax, statusx) => {
              if (statusx === 200) {
                ScriptLoading.markContentLogicResourceLoaded("flowProperties");
              }
              $scope.flowProperties = {};
              $scope.flowgroups = data2;
              for (let j = 0; data2.length > j; j++) {
                $scope.flowProperties[data2[j].OBJ_ID] = [];
                for (let i = 0; datax.length > i; i++) {
                  if (data2[j].SUPPORTED_PROPERTIES.indexOf(`,${datax[i].P_ID},`) !== -1) {
                    $scope.flowProperties[data2[j].OBJ_ID].push(datax[i]);
                  }
                }
              }
              if (statusx === 200) {
                ScriptLoading.markContentLogicResourceLoaded("flowPropertyGroups");
              }
            });
          });
        });
        Scripts.loadScriptTitlesByID(
          scriptID,
          $rootScope.loggedUser.language,
          (data, status) => {
            $scope.titles = data;
            if (status === 200) {
              ScriptLoading.markMetadataResourceLoaded("scriptTitles");
            }
          },
        );
        Scripts.loadScriptJSByID(scriptID, (data, status) => {
          $rootScope.scriptjs = data;
          if (status === 200) {
            ScriptLoading.markMetadataResourceLoaded("scriptJS");
          }
        });

        loadMessages(scriptID);
      };

      // Used with script loading
      $scope.isAllLoaded = false;
      $scope.showDetailsBox = false;

      // get script id from url.
      const urlscript = $stateParams.scriptid;
      if (urlscript) {
        ScriptLoading.startLoading(() => {
          $scope.isAllLoaded = ScriptLoading.getLoadingFinished();
          $scope.showDetailsBox = false;
        });
        const modalInstance = $modal.open({
          animation: true,
          size: "md",
          templateUrl: "view/modal/loadingScript.html",
          backdrop: "static",
          controller: "LoadingScriptController",
        });
        modalInstance.result.then(() => {
          $scope.showDetailsBox = true;
          if (window.location.hash) {
            $timeout($anchorScroll);
          }
        });
        $scope.openScript(urlscript);
      }

      // updating view if language changes
      let initialwatch = true;
      $rootScope.$watch(
        "loggedUser",
        () => {
          if (initialwatch === true) {
            initialwatch = false;
          } else {
            $scope.language = $rootScope.loggedUser.language;
            if (selectedScript) {
              $scope.openScript(selectedScript);
            }
          }
        },
        true,
      );

      // Save changes to script. User clicked save changes -button in left menu
      // after modifying script.
      const scriptListener = $rootScope.$on("saveScriptChanges", () => {
        // $rootScope.changedFields="";
      });
      // without this row, navigating x-amount of scripts
      // you will end up saving x-amount of times the script on rootscope.on
      // 'savescriptchanges'.
      // ...weird.
      $scope.$on("$destroy", scriptListener);

      $scope.deleteField = "";

      // Use this to hide delete buttons
      $scope.textAreaFocusOut = function () {
        function focusThis() {
          $scope.deleteField = "";
        }

        $timeout(() => {
          focusThis();
        }, 200);
      };

      // Use this to show delete buttons
      $scope.textAreaFocus = function (field) {
        function focusThis() {
          $scope.deleteField = field;
        }

        $timeout(() => {
          focusThis();
        }, 300);
      };
    },
  ])
  .animation(".loading-box-animation", () => ({
    enter(element) {
      element.slideDown();
    },
    leave(element) {
      element.slideUp();
    },
  }))
  .animation(".script-details-animation", () => ({
    enter(element) {
      element.slideDown();
    },
  }));
